import { render, staticRenderFns } from "./Ktable.vue?vue&type=template&id=b7fb3294"
import script from "./Ktable.vue?vue&type=script&lang=js"
export * from "./Ktable.vue?vue&type=script&lang=js"
import style0 from "./Ktable.vue?vue&type=style&index=0&id=b7fb3294&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports